import React from 'react';
import { SearchResultsCount } from './SearchResultsCount';
import { SelectedItemsCount } from './SelectedItemsCount';
import { FilterActions, FilterActionsHandle } from './filterActions';
import ClearFiltersButton from './ClearFiltersButton';
import { GlobalFilters } from './globalFilters/GlobalFilters';
import { ViewsDropdown } from '../../settings/viewsManagement/ViewsDropdown';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { ActiveFilterPills } from './ActiveFilterPills';
import { CpsFacetValue, CpsFieldForView } from '@cs-cms/types';

interface CpsToolbarProps {
  onFilterActionsMount?: (actions: FilterActionsHandle) => void;
  initialFacets?: Record<string, CpsFacetValue[]>;
  compositeFilterDescriptor?: CompositeFilterDescriptor;
  columns?: CpsFieldForView[];
  onRemoveFilter?: (field: string, value?: string) => void;
}

export const CpsToolbar: React.FC<CpsToolbarProps> = ({
  onFilterActionsMount,
  initialFacets,
  compositeFilterDescriptor,
  columns,
  onRemoveFilter
}) => {
  return (
    <div className="cpsToolbarWrapper">
      <div className="cpsToolbar">
        <SearchResultsCount />
        <GlobalFilters initialFacets={initialFacets} />
        <div className="actionButtonsContainer">
          <ViewsDropdown />
          <ClearFiltersButton />
          <FilterActions onMountActions={onFilterActionsMount} />
        </div>
      </div>
      {onRemoveFilter && (
        <div className="activeFiltersRow">
          <ActiveFilterPills
            compositeFilter={compositeFilterDescriptor}
            columns={columns}
            onRemoveFilter={onRemoveFilter}
          />
        </div>
      )}
      <div className="selectedItemsRow">
        <SelectedItemsCount />
      </div>
    </div>
  );
};
